import { Box, Typography } from '@mui/material';
import { AIMessage, BaseMessage, HumanMessage } from '@langchain/core/messages';
import Markdown from '../../../components/Markdown';
import { Bubble } from './Bubble';
import { CopyButton } from './CopyButton';
import { contentText } from './messageContent';

export function MessageView({ message }: { message: BaseMessage }) {
  if (HumanMessage.isInstance(message)) {
    return <HumanMessageView message={message} />;
  }
  if (AIMessage.isInstance(message)) {
    return <AIMessageView message={message} />;
  }
  return null;
}

function HumanMessageView({ message }: { message: HumanMessage }) {
  return (
    <Bubble isUser>
      <Typography sx={{ whiteSpace: 'pre-wrap' }}>{contentText(message)}</Typography>
    </Bubble>
  );
}

function AIMessageView({ message }: { message: AIMessage }) {
  const text = contentText(message);
  if (!text) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mx: 0.5, mb: 0.5 }}>
        Agent
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 0.5,
          maxWidth: '80%',
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: 'grey.100',
          overflowWrap: 'anywhere',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Markdown>{text}</Markdown>
        </Box>
        <CopyButton text={text} />
      </Box>
    </Box>
  );
}
